import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  ResponsiveContainer,
  BarChart,
  PieChart,
  Pie,
  CartesianGrid,
  Cell,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  Legend,
} from 'recharts';
import { Box, Text, Grid } from 'grommet';

const StyledChartWrap = styled(Box)`
  height: 19rem;
  width: 100%;
`;

const GeoTrafficDistribution = ({
  small,
  geographyData,
  usIntlData,
  primaryText = 'var(--page-primary-text)',
  secondaryText = 'var(--page-secondary-text)',
  cardContent = null,
  formatInt,
  chartTooltip,
}) => (
  <Box direction="column" gap="1rem">
    <Box direction="column" gap="0.5rem">
      <Text color={primaryText} size="1rem" weight={700}>
        Geographic Traffic Distribution
      </Text>
      <Text color={secondaryText} size="0.8rem">
        Viewer concentration by country plus U.S. vs other countries
        split.
      </Text>
    </Box>
    <Box>
      {cardContent}
      <Grid
        columns={small ? ['100%'] : ['1.2fr', '0.8fr']}
        gap="1rem"
      >
        <StyledChartWrap>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={geographyData}
              layout="vertical"
              margin={{ left: 10, right: 10 }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="#E6EEF6" />
              <XAxis
                type="number"
                tick={{ fill: '#5D738A', fontSize: 11 }}
              />
              <YAxis
                type="category"
                dataKey="territory"
                width={96}
                tick={{ fill: '#5D738A', fontSize: 11 }}
              />
              <Tooltip
                {...chartTooltip}
                labelFormatter={(label, payload) => (
                  payload?.[0]?.payload?.fullTerritory || label
                )}
                formatter={(value) => formatInt(value)}
              />
              <Bar
                dataKey="estimatedViewers"
                fill="#0EA5A2"
                radius={[0, 4, 4, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </StyledChartWrap>
        <StyledChartWrap>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={usIntlData}
                dataKey="viewers"
                nameKey="segment"
                cx="50%"
                cy="50%"
                outerRadius={70}
                innerRadius={30}
                paddingAngle={4}
              >
                {usIntlData.map((entry, index) => (
                  <Cell
                    key={entry.segment}
                    fill={index === 0 ? '#2563EB' : '#14B8A6'}
                  />
                ))}
              </Pie>
              <Tooltip
                {...chartTooltip}
                formatter={(value) => formatInt(value)}
              />
              <Legend verticalAlign="bottom" />
            </PieChart>
          </ResponsiveContainer>
        </StyledChartWrap>
      </Grid>
    </Box>
  </Box>
);

GeoTrafficDistribution.propTypes = {
  small: PropTypes.bool.isRequired,
  usIntlData: PropTypes.array.isRequired,
  geographyData: PropTypes.array.isRequired,
  formatInt: PropTypes.func.isRequired,
  chartTooltip: PropTypes.object.isRequired,
  cardContent: PropTypes.node,
  primaryText: PropTypes.string,
  secondaryText: PropTypes.string,
};

export default GeoTrafficDistribution;
